import TransactionsTable from "./transactions.table"
import SendButton from "./send.button"
import ReceiveButton from "./receive/receive.button"

export default function TransactionsScreen() {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-row justify-between">
        <div className="text-xl font-semibold">Transactions</div>
        <div className="flex flex-row gap-4">
          <SendButton />
          <ReceiveButton />
        </div>
      </div>
      <TransactionsTable />
    </div>
  )
}
